
































































































































import Vue from "vue";
import axios from "axios";

import "vue-simple-suggest/dist/styles.css";

import VariableInput, { VariableInputProps } from "@/components/util/VariableInput.vue";
import CorpInformationForm from "@/views/corporate/forms/CorpInformationForm.vue";
import { deletePaymentInformationCorporation } from "@/api/Corporation";
import { getCorpInfo, updateCorpInfo } from "@/api/CorpInfo";
import { GetCorpResponse } from "@/api/dto/CorpInfo";
import { CorporateUserRegisterData } from "@/api/dto/Corporation";
import DeleteAccountConfirmModal from "@/parts/mypage/DeleteAccountConfirmModal.vue";
import SettlementRadioButton from "@/parts/corporate/SettlementRadioButton.vue";
import CodeThemeRadioButton from "@/parts/mypage/CodeThemeRadioButton.vue";

import { getUserProfile, updateUserProfileCorporate } from "@/api/UserProfile";
import { IconUpdateFlag, GetUserProfileResponse } from "@/api/dto/UserProfile";
import { LoginCorporationData } from "@/api/dto/Login";
import { ErrorResponse } from "@/api/dto/Error";
import CorporateSideTabs from "@/parts/corporate/CorporateSideTabs.vue";
import { UserProfile } from '@/api/dto/UserProfile';

interface Data {
  inputNickname: string;
  profileUpdateFlag: IconUpdateFlag;
  profileData: GetUserProfileResponse;
  corpInfoForm: GetCorpResponse;
  corporateData: LoginCorporationData;
  deleteAccountConfirmModal: boolean;
  deleteCorporateConfirmModal: boolean;
  companyUserRegisterData: CorporateUserRegisterData;
  isApiProcessing: boolean;
}

export default Vue.extend({
  name: "AccountInfo",
  components: {
    VariableInput,
    SettlementRadioButton,
    CodeThemeRadioButton,
    CorpInformationForm,
    DeleteAccountConfirmModal,
    CorporateSideTabs,
  },
  props: {
    modeName: String,
  },
  watch: {
    'profileData.codeTheme': function(newVal, oldVal) {
      if (oldVal) {
        this.updateUserProfile();
      }
    },
    'corpInfoForm.paymentType': function(newVal, oldVal) {
      if (oldVal) {
        this.updateCorpInfo();
      }
    },
  },
  data(): Data {
    this.$store.commit("setMode", { mode: "account" });
    return {
      inputNickname: "",
      profileUpdateFlag: "0",
      profileData: {} as GetUserProfileResponse,
      corpInfoForm: {} as GetCorpResponse,
      corporateData: {} as LoginCorporationData,
      deleteAccountConfirmModal: false,
      deleteCorporateConfirmModal: false,
      companyUserRegisterData: {} as CorporateUserRegisterData,
      isApiProcessing: false,
    };
  },
  async beforeRouteEnter(to, route, next) {
    const userProfRes = await getUserProfile();
    const corpInfoRes = await getCorpInfo();
    next((vm) => {
      (vm.$data as Data).profileData = userProfRes;
      (vm.$data as Data).inputNickname = userProfRes.nickname;
      (vm.$data as Data).corpInfoForm = corpInfoRes;
    });
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    mode(): string {
      return this.$store.state.mode;
    },
    isDisabled() {
      return true;
    },
    corporateId(): string {
      let user = this.$store.getters.userProfile as UserProfile;
      return user.corporationsData.corporateId;
    },
    isManagementUser(): boolean {
      let user = this.$store.getters.userProfile as UserProfile;
      return user.corporationsData.isManagementUser;
    },
    registeredCreditCard(): boolean {
      let user = this.$store.getters.userProfile as UserProfile;
      return user.corporationsData.registeredCreditCard;
    },
    paymentType(): string {
      let user = this.$store.getters.userProfile as UserProfile;
      return user.corporationsData.paymentType;
    },
  },
  methods: {
    showToast(msg: string) {
      this.$emit("toast", msg);
    },
    errorToast(msg: string) {
      this.$emit("errorToast", msg);
    },
    changeMode(key: string) {
      this.$store.commit("setMode", { mode: key });
    },
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        this.profileData = res
      } catch (e) {
        console.log(e);
      }
    },
    async updateUserProfile() {
      if(!this.inputNickname){
        this.$emit("errorToast", "表示名は必須入力項目です");
        return;
      }

      try {
        await updateUserProfileCorporate({
          nickname: this.inputNickname,
          codeTheme: this.profileData.codeTheme,
        })
        this.$store.dispatch('userUpdate');
        this.$emit('toast', 'ユーザー情報を更新しました');
      } catch (e) {
        if (axios.isAxiosError(e)) {
          const res = (e.response?.data as ErrorResponse);
          if (res.code == '7007') {
            this.$emit('errorToast', '氏名は20文字以内で入力してください');
          } else {
            this.$emit('errorToast', res.message);
          }
          return; 
        }
        this.$emit('errorToast', '更新に失敗しました。時間おいて再度お試しください');
      }
    },
    async updateCorpInfo() {
      try {
        await updateCorpInfo(this.corpInfoForm);
        this.$store.dispatch("userUpdate");
        this.$emit("toast", "決済方法を更新しました");
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit("errorToast", "決済方法の更新に失敗しました。しばらく経ってからやり直してください。");
          } else {
            this.$emit("errorToast", resError.message);
          }
        }
      }
    },
    /**
     * パスワード設定画面に遷移する
     */
    toChangePassword() {
      this.$router.push({ name: "CorpPasswordChange" });
    },
    /**
     * メールアドレス設定画面に遷移する
     */
    toChangeMailAddress() {
      this.$router.push({ name: "CorpMailAddressChange" });
    },
    /**
     * 法人決済情報設定画面に遷移する
     */
     toSettingsPayment() {
      this.$router.push({ name: 'CorpSettingsPayment' });
    },
    /**
     * 決済情報削除APIを呼ぶ
     */
     async deletePaymentInformation() {
      try {
        this.isApiProcessing = true;
        await deletePaymentInformationCorporation();
        // ユーザー情報取得し更新
        this.$store.dispatch('userUpdate');
        this.$emit('toast', '決済情報を削除しました');
      } catch (e) {
        console.error(e);
        this.$emit('errorToast', '決済情報の削除に失敗しました');
      } finally {
        this.isApiProcessing = false;
      }
    },
    /**
     * アカウント削除モーダルを開く
     */
    openDeleteAccountModal() {
      this.deleteAccountConfirmModal = true;
    },
    /**
     * 法人アカウント削除モーダルを開く
     */
    openCorpDeleteAccountModal() {
      this.deleteCorporateConfirmModal = true;
    },   
  },
});
